const serviceModule = {
  homeInfo: {
    url: '/b2b/homeInfo',
    method: 'get'
  },
  login: {
    url: '/b2b/login',
    method: 'post'
  },
  chkLogin: {
    url: '/b2b/chkLogin',
    method: 'get'
  },
  adtAdvertView: {
    url: '/b2b/adtAdvertView',
    method: 'get'
  },
  godList: {
    url: '/b2b/godList',
    method: 'post'
  },
  godDetail: {
    url: '/b2b/godDetail',
    method: 'get'
  }
};
const apiSetting = {...serviceModule};

export default apiSetting
